const NEXT = Symbol("NEXT");
const LOGIN = Symbol("LOGIN");
const RESTRICTED = Symbol("RESTRICTED");
const EXPIRED = Symbol("EXPIRED");

export class AccesDecisionService{
  constructor(oauth2Service) {
    this.oauth2Service = oauth2Service;
  }

  /**
   * Intégration avec le router vue
   * @param {*} args
   * @returns
   */
  beforeRouterEnter(args = {}) {
    const {
      login = { name: "startlogin" },
      restricted = { name: "restricted" },
      logout = { name: "logout" },
    } = args;

    return (to, from, next) => {
      const decision = this.accesDecision(to);
      if (NEXT === decision) {
        next();
      } else if (RESTRICTED === decision) {
        next(restricted);
      } else if (EXPIRED === decision) {
        next(logout);
      } else {
        // il s'agit d'un login
        const target = {
          ...login,
          params: {
            to,
          },
        };
        next(target);
      }
    };
  }

  mayNavigateToMenu(router, route) {
    const out = router.resolve(route);
    if (out.resolved.matched.length) {
      return this.accesDecision(out.resolved) === NEXT;
    }
    return false;
  }

  mayNavigateTo(to) {
    return this.accesDecision(to) === NEXT;
  }

  accesDecision(to) {
    if (to.meta && typeof to.meta.auth === "function") {
      if (this.oauth2Service.logged()) {

        if (to.meta.auth(this)) {
          if (this.oauth2Service.expired()) {
            return EXPIRED;
          }

          return NEXT;
        } else {
          return RESTRICTED;
        }


      } else {
        // doit être loggé
        return LOGIN;
      }
    } else {
      //pas de controle d'accès
      return NEXT;
    }
  }

  authentified() {
    return this.oauth2Service.logged();
  }
}
